import { Koi } from '@ksyos/koi';

export interface IAsset {
    filename: string;
    placement?: number;
    s3Id: string;
    thumbnailDataUrl: string;
}

export const asset = Koi.object({
    filename: Koi.string().max(255),
    s3Id: Koi.string().uuid(),
});

export const assets = Koi.array().items(asset);
